import { render, staticRenderFns } from "./tariff-code.vue?vue&type=template&id=2ed1afca&"
import script from "./tariff-code.vue?vue&type=script&lang=js&"
export * from "./tariff-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed1afca')) {
      api.createRecord('2ed1afca', component.options)
    } else {
      api.reload('2ed1afca', component.options)
    }
    module.hot.accept("./tariff-code.vue?vue&type=template&id=2ed1afca&", function () {
      api.rerender('2ed1afca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/TariffCodeComponent/tariff-code.vue"
export default component.exports